import { InputHTMLAttributes } from 'react';

import Icon from '../Icon';

import './styles.scss';

export type CheckboxProps = InputHTMLAttributes<HTMLInputElement>;

export default function Checkbox({
  className = '',
  checked,
  value = '0',
  children,
  onChange,
  style,
  ...rest
}: CheckboxProps) {
  return (
    <label className={`checkbox ${className}`} style={style}>
      <div className="checkbox-input-container">
        <input
          className="checkbox-input"
          type="checkbox"
          checked={checked}
          value={Number(checked) || value} // NOTE devise want the value to be either 1 or 0
          onChange={onChange}
          role="checkbox"
          {...rest}
        />
        <Icon className="checkbox-icon" icon="check" />
      </div>
      {children && <span className="checkbox-text">{children}</span>}
    </label>
  );
}
